'use client';
import { type DependencyList, useRef } from 'react';

interface ConstantState<T> {
  deps: DependencyList;
  value: T;
}

function depsEqual(a: DependencyList, b: DependencyList) {
  return a.length === b.length && a.every((value, index) => Object.is(value, b[index]));
}

/** Lazy factory — recomputes only when `deps` change (default: once per mount). */
export function useConstant<T>(factory: () => T, deps: DependencyList = []): T {
  const stateRef = useRef<ConstantState<T> | null>(null);
  if (!stateRef.current || !depsEqual(stateRef.current.deps, deps)) {
    stateRef.current = { deps, value: factory() };
  }
  return stateRef.current.value;
}
